import { useState } from "react";
import { Wand2 } from "lucide-react";
import { MediaStudio } from "../components/MediaStudio";
import { Pills } from "../components/AiHtml";

const COST = { "4s": 120, "6s": 160, "8s": 200 };

export default function VideoStudio() {
  const [duration, setDuration] = useState("4s");
  const [aspect, setAspect] = useState("16:9");
  return (
    <MediaStudio
      type="video" label="Video Studio" title="AI video generation" desc="Short promo clips and reels with Veo 3.1 Fast, with audio."
      cost={COST[duration]} payload={{ duration, aspect }} waitLabel="Rendering your video... this can take 1-3 minutes"
      controls={
        <div className="grid sm:grid-cols-3 gap-5">
          <div><p className="label-mono mb-2">Duration</p><Pills testPrefix="video-duration" value={duration} onChange={setDuration} options={[{ value: "4s", label: "4s · 120cr" }, { value: "6s", label: "6s · 160cr" }, { value: "8s", label: "8s · 200cr" }]} /></div>
          <div><p className="label-mono mb-2">Aspect</p><Pills testPrefix="video-aspect" value={aspect} onChange={setAspect} options={[{ value: "16:9", label: "16:9 Landscape" }, { value: "9:16", label: "9:16 Reel" }]} /></div>
          <div><p className="label-mono mb-2">Prompt enhancer</p><span data-testid="video-enhancer-on" className="pill pill-on inline-flex items-center gap-1.5"><Wand2 size={13} /> On</span></div>
        </div>
      }
    />
  );
}
